import * as React from "react";

function IconTwitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
        fill="#fff"
      />
      <path
        d="M24 10.467a6.425 6.425 0 01-1.885.53 3.358 3.358 0 001.443-1.862 6.478 6.478 0 01-2.085.817 3.24 3.24 0 00-2.396-1.063c-2.119 0-3.676 2.027-3.198 4.132-2.727-.14-5.146-1.48-6.765-3.516-.86 1.513-.446 3.492 1.015 4.494a3.208 3.208 0 01-1.486-.421c-.036 1.56 1.054 3.018 2.633 3.343a3.211 3.211 0 01-1.483.057c.418 1.337 1.63 2.31 3.067 2.337A6.484 6.484 0 018 20.71a9.126 9.126 0 005.032 1.512c6.095 0 9.538-5.278 9.33-10.012A6.78 6.78 0 0024 10.467z"
        fill="#149FF2"
      />
    </svg>
  );
}

export default IconTwitter;
